__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/phx-rel-r26.1.4-01242026/_next/";